import { render, staticRenderFns } from "./CustomCarousel.vue?vue&type=template&id=747d34c3&scoped=true&"
import script from "./CustomCarousel.vue?vue&type=script&lang=js&"
export * from "./CustomCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CustomCarousel.vue?vue&type=style&index=0&id=747d34c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d34c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
installComponents(component, {VCarousel,VCarouselItem})
